import React from "react"
import message from "../../assets/images/inbox/direct-message.svg"
import { ReactComponent as PersonCircle } from "../../assets/images/inbox/person-circle.svg";
import { ReactComponent as PeopleFill } from "../../assets/images/inbox/people-fill.svg";
import video from "../../assets/images/inbox/video.svg"
import commentBoard from "../../assets/images/inbox/comment-board.svg"
import newsFeed from "../../assets/images/inbox/news-feed.svg"
import "../../assets/scss/custom/inbox/DialogDetails.scss"

import { formatDate, getInitials, renderUserProfileIcon } from "./utils"
import { useDialogManager } from "./helperHooks/HelperContext";

const DialogsList = ({
  dialogs,
  handleDialogSelect,
  selectedDialog,
  allDialogs = false,
}) => {
  const { getDialogProfileImage } = useDialogManager();
  const GroupIcon = ({ comment }) => {
    return (
      <React.Fragment>
        <span className="type">
          {comment?.feature_type === 2 && (
            <img src={message} alt="Icon" className="icon-image" />
          )}
          {comment?.feature_type === 1 && (
            <img src={commentBoard} alt="Icon" className="icon-image" />
          )}
          {comment?.feature_type === 3 && (
            <img src={newsFeed} alt="Icon" className="icon-image" />
          )}
          {comment?.feature_type === 4 && (
            <img src={video} alt="Icon" className="icon-image" />
          )}
        </span>

        {/* {comment?.feature_type === 2 && comment?.unread_messages_count > 0 && (
          <span className="icon-notification">
            {comment?.unread_messages_count}
          </span>
        )} */}
      </React.Fragment>
    )
  }

  return (
    <section className="comments-list">
      {(!dialogs || dialogs?.length === 0) && (
        <span className="p-5">
          <i>No dialogs found</i>
        </span>
      )}
      {dialogs?.map((comment, index) => (
        <article
          key={index}
          style={comment?.data?.disabled ? { pointerEvents: "none", opacity: "0.5", cursor: "no-drop" } : {}}
          onClick={() => handleDialogSelect(comment)}
          className={`comment-item ${(selectedDialog?._id || selectedDialog?.menu_item_id) ===
            (comment?._id || comment?.menu_item_id)
            ? "active"
            : ""
            }`}
        >
          <React.Fragment>
            <div
              className="initial-character direct-messages-in"
              style={{
                background:
                  comment?.feature_type === 1
                    ? "#4fc0e8"
                    : comment?.feature_type === 2
                      ? "#75b35b"
                      : comment?.feature_type === 3
                        ? "#f4ab01"
                        : "#f8483c",
                color: "white",
              }}
            >

              {comment?.feature_type === 2 && comment?.type === 3 ? (() => {
                const matchedUser = comment?.userList?.find(
                  (user) => user?.display_name?.trim() === comment?.name?.trim()
                );
                const profilePic = matchedUser?.profile_pic?.file?.url;

                return profilePic ? (
                  <img
                    src={profilePic}
                    width="41"
                    height="41"
                    alt="Profile"
                    style={{ borderRadius: "18%" }}
                    loading="lazy"
                  />
                ) : (
                  <PersonCircle width="25px" height="25px" />
                );
              })() : comment?.feature_type === 2 && comment?.type === 2 ? (
                comment?.photo && comment.photo !== "null" ? (
                  <img
                    width="41"
                    height="41"
                    src={getDialogProfileImage(comment?.photo)}
                    alt="Group Avatar"
                    style={{ borderRadius: "18%" }}
                    loading="lazy"
                  />
                ) : (
                  <PeopleFill width="25px" height="25px" />
                )
              ) : (
                getInitials(comment?.name)
              )}
            </div>

            <div className="comment-details">
              <div className="user-details">
                <h4 className="comment-name text-truncate">
                  {comment?.feature_type === 3 ? "News Feed " : comment?.feature_type === 1 ? comment?.menu_item_name : comment?.experience_name ? comment?.experience_name : comment?.name}
                </h4>
                <h6 className="comment-text m-0 text-truncate">
                  {comment?.feature_type === 3 ? (
                    ""
                  ) : comment?.feature_type == 2 ? (
                    <strong style={{ color: "#000000" }}>
                      {comment?.subTitle ? comment?.subTitle : "----"}
                    </strong>
                  ) : (
                    comment?.subTitle
                  )}
                </h6>
                {comment?.type !== 3 && (
                  <h6 className="comment-text mt-1">
                    {/* {comment?.userList?.length > 0 && (
                      <>
                        {renderUserProfileIcon(comment?.userList[0])}
                        {comment?.userList?.length > 1 &&
                          renderUserProfileIcon(comment?.userList[1])}

                        {comment?.userList?.length > 2
                          ? `+ ${comment?.userList?.length - 2} ` +
                            (comment?.userList?.length - 2 === 1
                              ? "member"
                              : "members")
                          : ""}
                      </>
                    )} */}
                  </h6>
                )}
                <h6 className="comment-text">{comment?.last_message}</h6>
              </div>
              <div className="time-details">
                <span
                  style={{ width: "60px" }}
                  className="comment-time d-flex flex-wrap text-end"
                >
                  {formatDate(
                    comment?.last_message_date_sent * 1000,
                    comment?._id
                  )}
                </span>
                <span className="comment-time"></span>
              </div>
            </div>
          </React.Fragment>
        </article>
      ))}
    </section>
  )
}

export default DialogsList
